import { DateTimePicker } from "@material-ui/pickers";
import React from "react";
import { Switch, Route, Redirect } from "react-router";

/**
 * 将路由配置渲染成节点
 * @param {Array} routes switch路由列表
 * @param {String|Number} authed 当前账号权限,不传则可以访问该routes列表的所有路由
 * @param {Array} multipleRoutes 非switch路由列表，将会在Switch节点前渲染Route
 * @param {Object} extraProps 添加额外的Route props
 * @param {Object} switchProps Switch props
 */
function renderRoutes(routes, user, multipleRoutes, extraProps, switchProps) { 
  
  let userPermissions = Object.values(user.role)
  if(!Array.isArray(userPermissions)){
    userPermissions =[] 
  }  
  routes = routes.filter((route,index,self)=>{
    return !(route.auth != null && Array.isArray(route.auth) && (!route.auth.find(i=>userPermissions.includes(i))))
  }) 

  //console.log(routes)
  let list = [];
  //if (authed) authed = String(authed);
  const mapFunc = (R) =>
    R.map((route, i) => ( 
      <Route
        key={route.key || i}
        path={route.path}
        exact={route.exact}
        strict={route.strict}
        render={(props) => {  
          if(user.refreshExpireTime*1000 < Date.now() && route.path && route.path.indexOf("auth") <0){ 
            return <Redirect to="/auth/login" />;  
          }else{ 
              if (route.auth != null && Array.isArray(route.auth) && (!route.auth.find(i=>userPermissions.includes(i)))) {  
                return <Redirect to="/errors/error-404" />;  
            }
            else {  
              return route.render
              ? route.render({ ...props, ...extraProps, route: route })
              : route.component && <route.component {...props} {...extraProps} route={route} />; 
            }
          }
         
        }}
      />
    ));

  if (routes) {
    list.push(
      <Switch {...switchProps} key="SwitchRoutes">
        {mapFunc(routes)}
      </Switch>
    );
    multipleRoutes && list.unshift(...mapFunc(multipleRoutes));
    return list;
  }
}

export default renderRoutes;
 